<template>
  <div class="view-product-register-module">
    <step-title :title="moduleTitle" />

    <div class="row">
      <div class="view-content-aside col-lg-3 pr-0 d-none d-lg-block">
        <steps
          class="pt-6 mt-3"
          :step="currentStep"
          :names="steps"
          @change-step="v => (currentStep = v)"
        />
      </div>

      <div class="col-lg-9 pl-6">
        <div v-if="currentStep === 1">
          <register-module-basic
            v-if="!$route.params.module_id"
            :product-id="$route.params.id"
            :form="form"
          />

          <action-dispatcher
            v-else
            action="membersModules/getDetails"
            :parameters="$route.params.module_id"
            @success="editModule"
          >
            <register-module-basic
              :form="form"
              :module="module"
              :product-id="$route.params.id"
            />
          </action-dispatcher>
        </div>
        <div v-if="currentStep === 2">
          <register-module-customization
            :product-id="$route.params.id"
            :form="form"
            :errors="errors"
          />
        </div>

        <div
          class="d-flex flex-column flex-md-row d-block justify-content-between mt-9 pb-5"
        >
          <button
            class="btn mb-5 btn-outline-secondary px-5 order-3 order-md-0"
            @click="back"
          >
            <span v-if="currentStep === 1">Cancelar</span>
            <span v-else class="d-flex align-items-center">
              <i class="icon-angle-left mr-6" />
              Voltar
            </span>
          </button>
          <div class="flex-fill"></div>
          <button
            class="btn btn-outline-secondary px-5 mb-5 mr-md-3 order-2 order-md-1"
            :disabled="!isValid"
            @click="saveAsDraft"
          >
            Salvar Rascunho
          </button>
          <button
            v-if="currentStep === 2"
            class="btn mb-5 mr-md-3 px-5 order-1 order-md-2"
            :class="
              isValid ? 'btn-new-outline-primary ' : 'btn-outline-secondary'
            "
            :disabled="!isValid"
            @click="next((createNew = true))"
          >
            <loading :show="loadingSubmit && createNew">
              Salvar e criar novo
            </loading>
          </button>
          <button
            class="btn d-flex mb-5 align-items-center px-5 order-0 order-md-3"
            :class="isValid ? 'btn-primary ' : 'btn-secondary'"
            :disabled="!isValid"
            @click="next((createNew = false))"
          >
            <loading
              v-if="currentStep === steps.length"
              :show="loadingSubmit && !createNew"
            >
              Salvar
            </loading>
            <span v-else class="d-flex align-items-center">
              Próximo
              <i class="icon-angle-right ml-6" />
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import RegisterModuleBasic from "@/components/product/details/content/RegisterModuleBasic";
import RegisterModuleCustomization from "@/components/product/details/content/RegisterModuleCustomization";
import { formFields, toComputerDate, toHumanDate } from "@/functions/helpers";
import MemberAreaMixin from "@/mixins/memberArea.js";
import get from "lodash/get";
import { mapState } from "vuex";

export default {
  mixins: [MemberAreaMixin],
  components: {
    RegisterModuleBasic,
    RegisterModuleCustomization
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersModules", ["module"]),
    moduleTitle() {
      return !this.$route.params.module_id ? "Novo Módulo" : "Editando Módulo";
    },
    lessonRoute() {
      let pastQuery = {};
      if (this.$route.params.module_id) {
        pastQuery = {
          query: this.$route.params.module_id
        };
      }
      return {
        name: "product-members-lesson-add",
        params: { id: this.$route.params.id },
        ...pastQuery
      };
    },
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        {
          link: "product-member-area-modules",
          title: "Conteúdo"
        },
        {
          title: !this.$route.params.module_id ? "Novo Módulo" : "Editar Módulo"
        }
      ];
    },
    sortedLessons: {
      get() {
        return [...this.lessons].sort((a, b) => a.sort - b.sort);
      },
      set(val) {
        for (let i in this.lessons) {
          for (let j in val) {
            if (this.lessons[i].id === val[j].id) {
              this.lessons[i].sort = j;
            }
          }
        }
        this.saveOrder();
      }
    },
    navOptions() {
      return [
        { id: "info", name: "Conteúdo" },
        ...(this.module && !this.module.parent
          ? [{ id: "submodules", name: "Submódulos" }]
          : []),
        { id: "lessons", name: "Aulas" }
      ];
    },
    isValid() {
      return this.form.name;
    }
  },
  data() {
    return {
      currentStep: 1,
      steps: ["Informações básicas", "Personalização"],
      createNew: false,
      ...formFields(
        [
          "name",
          "category_ids",
          "description",
          "picture",
          "picture_mobile",
          "header",
          "product_id",
          "parent",
          "days_to_release",
          "release_at",
          "cover",
          "cover_mobile",
          "cover_view_type",
          "cover_view_type_mobile",
          "link_video",
          "link_video_mobile"
        ],
        { category_ids: [] }
      ),
      nav: "info",
      modal: false,
      params: {
        product_id: this.$route.params.id,
        module_id: this.$route.params.module_id,
        limit: 1000,
        offset: 0
      },
      loading: false,
      loadingSubmit: false,
      search: "",
      editedIndex: null,
      responsive: {
        actions: [
          {
            text: "Editar aula",
            class: "",
            icon: "fa-solid fa-pen",
            confirmation: {
              enable: false
            },
            event: "edit"
          },
          {
            text: "Remover",
            class: "text-danger",
            icon: "icon-trash",
            confirmation: {
              enable: true,
              text: "Deseja mesmo excluir este módulo?"
            },
            event: "remove"
          }
        ]
      }
    };
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    saveOrder() {
      this.$store.dispatch(
        "membersLessons/reorder",
        this.lessons.map(lesson => ({
          ...lesson,
          module: lesson.module.id
        }))
      );
    },
    onPaginationUpdate(offset) {
      this.params.offset = offset;
      this.refresh();
    },
    editlesson(lesson) {
      this.$router.push({
        name: "product-members-lesson-edit",
        params: {
          id: this.$route.params.id,
          lesson: lesson.id
        }
      });
    },
    removelesson(lesson) {
      this.$store
        .dispatch("membersLessons/delete", lesson.id)
        .then(this.refresh);
    },
    editModule(response) {
      this.form = {
        ...response,
        category_ids: [...response.categories].map(c => c.id),
        link_video_mobile: get(response, "link_video_mobile", ""),
        link_video: get(response, "link_video", ""),
        cover_mobile: get(response, "picture_mobile", ""),
        cover: response.header,
        release_at: response.release_at
          ? toHumanDate(response.release_at)
          : null
      };
    },
    searching(v) {
      this.search = v;
    },
    refresh() {
      this.dispatch();
    },
    dispatch() {
      if (this.$route.params.module_id) {
        this.loading = true;
        this.$store.dispatch("membersLessons/get", this.params).finally(() => {
          this.loading = false;
        });
      }
    },
    saveAsDraft() {
      this.form.status = "draft";
      this.submit();
    },
    submit() {
      if (this.loadingSubmit) return;

      const data = {
        ...this.form,
        header: this.form.cover,
        picture_mobile: this.form.cover_mobile,
        product_id: this.params.product_id
      };

      delete data.cover;
      delete data.cover_mobile;

      let action = "membersModules/post";

      if (data.description?.length > 255) {
        this.$message.warning(
          "A descrição não pode conter mais que 255 caracteres"
        );
        return;
      }

      if (this.params.module_id) {
        data.id = this.params.module_id;
        action = data.parent ? "membersModules/putSub" : "membersModules/put";
      }

      if (!this.form.days_to_release) {
        data.days_to_release = 0;
      }

      data.release_at = data.release_at
        ? toComputerDate(data.release_at)
        : null;

      this.loadingSubmit = true;

      this.$store
        .dispatch(action, data)
        .then(() => {
          this.$message.success("Salvo com sucesso");
          if (this.createNew) {
            this.$router.go(0);
          } else {
            this.$router.go(-1);
          }
        })
        .catch(error => {
          this.$message.error(
            "Não foi possível salvar as informações do módulo"
          );
          this.errors = error.response.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    back() {
      if (this.currentStep === 1) {
        this.$router.go(-1);
      } else {
        this.currentStep--;
      }
    },
    next() {
      if (this.currentStep === this.steps.length) {
        this.form.status = "published";
        this.submit();
      } else {
        this.currentStep++;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.view-product-register-module {
  .handle {
    cursor: grab;
  }
  .icon-angle-right,
  .icon-angle-left {
    font-size: 18px;
    margin-bottom: 1px;
    font-weight: 900;
  }

  .card {
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.16);
    box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.32);

    &:hover {
      border: 1px solid rgba(207, 174, 255, 0.86);
    }

    .name {
      color: rgba(59, 59, 74, 0.9);
      font-size: 14px;
      font-weight: 400;
    }
  }
}
</style>
